const apiBaseUrl = "https://dev.sitesee.local:8080";
const cdnBaseUrl = "";
const logoutRedirectUri = "/";
const loginRedirectUri = "/auth-return";
const analyticsKey = "UA-108060256-1";
const mapsApiKey = "AIzaSyD9HByKStIFOYzoRX-__ev6qitZYQfUDzQ";
const siteKey = "6LfKCjoUAAAAAA0e-uUFvCjllB2_iaUMoym15wsE";
const tenant = "siteseeoutlook.onmicrosoft.com";
const clientId = "d31a7e41-3593-46fd-b797-ffd251851a5d";
const mapboxToken = "pk.eyJ1IjoicG1haG9uZXkiLCJhIjoiY2tpcGN0MW5yMGU3NTMxcnFwMXZld3FqcyJ9.gGY1Y2SvoTn4eeEd2mdmEg";
export { apiBaseUrl, cdnBaseUrl, logoutRedirectUri, loginRedirectUri, analyticsKey, mapsApiKey, siteKey, tenant, clientId, mapboxToken, };
//# sourceMappingURL=env.js.map